import { createContext, useContext } from "react";
/** @typedef {import("./MainPageContextTypes").MainPageContextType} MainPageContextType */

/** @type {import('react').Context<MainPageContextType | undefined>} */
export const MainPageContext = createContext(undefined);

/** @type {() => MainPageContextType} */
export function useMainPageContext() {
  const ctx = useContext(MainPageContext);
  if (!ctx) throw new Error("useMainPageContext must be used inside MainPageProvider");
  return ctx;
}
